import React, { useState, useEffect } from 'react';
import Form from './Form';
import { submitContactForm } from '../../utils/contactForm';
import './ContactFormModal.css';

const ContactFormModal = ({ isOpen, onClose }) => {
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = (formData) => {
    setSubmitStatus(null);
    submitContactForm(formData, { formSource: 'popup' }).then(({ success }) => {
      setSubmitStatus(success ? 'success' : 'error');
      if (success) {
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
        }, 2000);
      }
    });
  };

  useEffect(() => {
    if (!isOpen) setSubmitStatus(null);
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="contact-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-modal-title"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="contact-modal-box">
        <button
          type="button"
          className="contact-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <Form
          variant="modal"
          id="contact-form-popup"
          showOrganisationField
          onSubmit={handleSubmit}
          submitStatus={submitStatus}
          successMessage="Thank you! Your message has been sent."
          errorMessage="Something went wrong. Please try again or email us directly."
        />
      </div>
    </div>
  );
};

export default ContactFormModal;
